"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classic33 = void 0;
const ComponentType_1 = require("../components/ComponentType");
const UIComponentType_1 = require("../components/UIComponentType");
const UIComponent_1 = require("../config/UIComponent");
exports.classic33 = {
    control: [
        {
            id: 1,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Controls',
                includeConnectionText: true,
            },
        },
        {
            id: 2,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    props: {
                        advancedScreenTitle: 'Inside Lights',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.LIGHT,
                            controlId: 1,
                            props: {
                                timeoutOverride: 10000,
                            },
                        },
                    ],
                    tileLabelOverride: 'Inside',
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.LIGHT,
                            controlId: 2,
                        },
                    ],
                    tileLabelOverride: 'Outside',
                },
            ],
        },
        {
            id: 3,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.INVERTER,
                            controlId: 10,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    props: {
                        nameOverride: 'Vent Fans',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.VENT_FAN,
                            controlId: 3,
                            props: {
                                timeoutOverride: 12000,
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.VENT_FAN,
                            controlId: 4,
                            props: {
                                timeoutOverride: 12000,
                            },
                        },
                    ],
                },
            ],
        },
        {
            id: 4,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.AWNING,
                            controlId: 20,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.WINDOW_SHADE,
                            controlId: 18,
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.WINDOW_SHADE,
                            controlId: 19,
                        },
                    ],
                    tileLabelOverride: 'Shades',
                },
            ],
        },
        {
            id: 5,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'HVAC',
                    props: {
                        modeWhiteList: [
                            'cool',
                            'heat',
                            'fanOnly',
                            'off',
                        ],
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.HVAC,
                            controlId: 21,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'HVAC',
                    props: {
                        modeWhiteList: [
                            'cool',
                            'heat',
                            'fanOnly',
                            'off',
                        ],
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.HVAC,
                            controlId: 22,
                        },
                    ],
                },
            ],
        },
        {
            id: 6,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Modes',
            },
        },
        {
            id: 7,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Square',
                    props: {
                        mode: 'On Board',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.MODE,
                            controlId: 23,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Square',
                    props: {
                        mode: 'Away',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.MODE,
                            controlId: 26,
                        },
                    ],
                },
                {
                    id: 3,
                    form: 'Square',
                    props: {
                        mode: 'Sleep',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.MODE,
                            controlId: 25,
                        },
                    ],
                },
                {
                    id: 4,
                    form: 'Square',
                    props: {
                        mode: 'Cinema',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.MODE,
                            controlId: 24,
                        },
                    ],
                },
            ],
        },
        {
            id: 8,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Battery',
            },
        },
        {
            id: 9,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'FullWidth',
                    bindings: [
                        {
                            kind: 'synthetic',
                            type: UIComponent_1.SyntheticType.BatteryDisconnect,
                            controlId: 12,
                            props: {
                                timeoutOverride: 15000,
                            },
                        },
                    ],
                },
            ],
        },
    ],
    monitor: [
        {
            id: 1,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Systems',
                includeConnectionText: true,
            },
        },
        {
            id: 2,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TIRE,
                            controlId: 13,
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TIRE,
                            controlId: 14,
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TIRE,
                            controlId: 15,
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TIRE,
                            controlId: 16,
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TIRE,
                            controlId: 17,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'synthetic',
                            type: UIComponent_1.SyntheticType.Router,
                        },
                    ],
                },
            ],
        },
        {
            id: 3,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    props: {
                        disableWhenBatteryDisconnected: true,
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.SHORE_POWER,
                            controlId: 11,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.BATTERY,
                            controlId: 12,
                        },
                    ],
                    tileLabelOverride: 'Battery',
                },
            ],
        },
        {
            id: 4,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Tank Levels',
            },
        },
        {
            id: 5,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Tanks',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 8,
                            props: {
                                tankType: 'propane',
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 9,
                            props: {
                                tankType: 'propane',
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 5,
                            props: {
                                tankType: 'freshWater',
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 6,
                            props: {
                                tankType: 'greyWater',
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 7,
                            props: {
                                tankType: 'wasteWater',
                            },
                        },
                    ],
                },
            ],
        },
        {
            id: 6,
            type: UIComponentType_1.UIComponentType.LastUpdated,
        },
        {
            id: 7,
            type: UIComponentType_1.UIComponentType.Alerts,
        },
    ],
    components: [
        {
            id: 1,
            iid: [
                9,
            ],
            name: 'Main Ceiling Lts',
            type: ComponentType_1.ComponentType.LIGHT,
            props: {
                dimmable: true,
                maxActuationTimeInMs: 10000,
            },
        },
        {
            id: 2,
            iid: [
                61,
            ],
            name: 'Exterior Lt. Master',
            type: ComponentType_1.ComponentType.LIGHT,
            props: {
                dimmable: false,
            },
        },
        {
            id: 3,
            iid: [
                1,
                21,
                76,
                120,
                77,
                119,
                21,
            ],
            name: 'Front Fan',
            type: ComponentType_1.ComponentType.VENT_FAN,
            props: {
                fanIid: 21,
                hasLid: true,
                openOnIid: 120,
                lidOpenIid: 76,
                closeOffIid: 119,
                lidCloseIid: 77,
                speedCommandIid: 21,
                maxActuationTimeInMs: 12000,
            },
        },
        {
            id: 4,
            iid: [
                1,
                128,
                44,
                120,
                18,
                119,
                128,
            ],
            name: 'Rear Fan',
            type: ComponentType_1.ComponentType.VENT_FAN,
            props: {
                fanIid: 128,
                hasLid: true,
                openOnIid: 120,
                lidOpenIid: 44,
                closeOffIid: 119,
                lidCloseIid: 18,
                speedCommandIid: 128,
                maxActuationTimeInMs: 12000,
            },
        },
        {
            id: 5,
            iid: [
                16,
                6,
            ],
            name: 'Fresh Water',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 50,
                hasHeater: true,
                heaterIid: 6,
            },
        },
        {
            id: 6,
            iid: [
                34,
            ],
            name: 'Grey Water',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 50,
                hasHeater: false,
            },
        },
        {
            id: 7,
            iid: [
                81,
            ],
            name: 'Waste Water',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 50,
                hasHeater: false,
            },
        },
        {
            id: 8,
            iid: [
                14,
            ],
            name: 'LP Tank 1',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 9,
                hasHeater: false,
            },
        },
        {
            id: 9,
            iid: [
                15,
            ],
            name: 'LP Tank 2',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 9,
                hasHeater: false,
            },
        },
        {
            id: 10,
            iid: [
                28,
            ],
            name: 'Inverter',
            type: ComponentType_1.ComponentType.INVERTER,
        },
        {
            id: 11,
            iid: [
                107,
            ],
            name: 'Shore Power',
            type: ComponentType_1.ComponentType.SHORE_POWER,
        },
        {
            id: 12,
            iid: [
                10,
                32,
            ],
            name: 'Trailer Battery Voltage',
            type: ComponentType_1.ComponentType.BATTERY,
            props: {
                disconnectIid: 32,
                hasDisconnect: true,
                maxActuationTimeInMs: 15000,
            },
        },
        {
            id: 13,
            iid: [
                65,
            ],
            name: 'Front Left Tire',
            type: ComponentType_1.ComponentType.TIRE,
            props: {
                axle: 0,
                isSpare: false,
                highTemp: 140,
                position: 0,
                lowPressure: 70,
                highPressure: 95,
                veryLowPressure: 60,
            },
        },
        {
            id: 14,
            iid: [
                66,
            ],
            name: 'Front Right Tire',
            type: ComponentType_1.ComponentType.TIRE,
            props: {
                axle: 0,
                isSpare: false,
                highTemp: 140,
                position: 1,
                lowPressure: 70,
                highPressure: 95,
                veryLowPressure: 60,
            },
        },
        {
            id: 15,
            iid: [
                81,
            ],
            name: 'Rear Left Tire',
            type: ComponentType_1.ComponentType.TIRE,
            props: {
                axle: 1,
                isSpare: false,
                highTemp: 140,
                position: 0,
                lowPressure: 70,
                highPressure: 95,
                veryLowPressure: 60,
            },
        },
        {
            id: 16,
            iid: [
                82,
            ],
            name: 'Rear Right Tire',
            type: ComponentType_1.ComponentType.TIRE,
            props: {
                axle: 1,
                isSpare: false,
                highTemp: 140,
                position: 1,
                lowPressure: 70,
                highPressure: 95,
                veryLowPressure: 60,
            },
        },
        {
            id: 17,
            iid: [
                67,
            ],
            name: 'Spare Tire',
            type: ComponentType_1.ComponentType.TIRE,
            props: {
                axle: 5,
                isSpare: true,
                highTemp: 140,
                position: 0,
                lowPressure: 70,
                highPressure: 95,
                veryLowPressure: 60,
            },
        },
        {
            id: 18,
            iid: [
                75,
            ],
            name: 'Day Shades',
            type: ComponentType_1.ComponentType.WINDOW_SHADE,
            props: {
                shadeIid: 75,
            },
        },
        {
            id: 19,
            iid: [
                16,
            ],
            name: 'Night Shades',
            type: ComponentType_1.ComponentType.WINDOW_SHADE,
            props: {
                shadeIid: 16,
            },
        },
        {
            id: 20,
            iid: [
                0,
                14,
                54,
                55,
                56,
                57,
            ],
            name: 'Awning',
            type: ComponentType_1.ComponentType.AWNING,
            props: {
                canLock: true,
                openIid: 54,
                closeIid: 55,
                hasLight: true,
                lightIid: 14,
                tiltLeftIid: 56,
                tiltRightIid: 57,
            },
        },
        {
            id: 21,
            iid: [
                0,
                30,
                130,
                131,
            ],
            name: 'Front HVAC',
            type: ComponentType_1.ComponentType.HVAC,
            props: {
                modes: [
                    'heat',
                    'cool',
                    'fanOnly',
                ],
                canLock: true,
                modeIid: 30,
                fanSpeeds: 2,
                setTempIid: 131,
                fanSpeedIid: 130,
                maxTemperature: 85,
                minTemperature: 65,
            },
        },
        {
            id: 22,
            iid: [
                1,
                132,
                134,
                135,
            ],
            name: 'Rear HVAC',
            type: ComponentType_1.ComponentType.HVAC,
            props: {
                modes: [
                    'heat',
                    'cool',
                    'fanOnly',
                ],
                canLock: true,
                modeIid: 132,
                fanSpeeds: 2,
                setTempIid: 135,
                fanSpeedIid: 134,
                maxTemperature: 85,
                minTemperature: 65,
            },
        },
        {
            id: 23,
            iid: [
                49,
            ],
            name: 'On Board Mode',
            type: ComponentType_1.ComponentType.MODE,
        },
        {
            id: 24,
            iid: [
                15,
            ],
            name: 'Cinema Mode',
            type: ComponentType_1.ComponentType.MODE,
        },
        {
            id: 25,
            iid: [
                47,
            ],
            name: 'Sleep Mode',
            type: ComponentType_1.ComponentType.MODE,
        },
        {
            id: 26,
            iid: [
                104,
            ],
            name: 'Away Mode',
            type: ComponentType_1.ComponentType.MODE,
        },
        {
            id: 27,
            iid: [
                125,
                124,
                54,
                55,
                78,
                64,
                79,
            ],
            name: 'Awning',
            type: 'v1awning',
            props: {
                canLock: true,
                openIid: 54,
                closeIid: 55,
                closedIid: 78,
                lockedIid: 125,
                movingIid: 79,
                openedIid: 64,
                unlockedIid: 124,
            },
        },
    ],
    scheduling: [
        {
            controlId: 1,
            friendlyName: 'Inside Lights',
        },
        {
            controlId: 2,
            friendlyName: 'Outside Lights',
        },
        {
            controlId: 10,
            friendlyName: 'Inverter',
        },
        {
            controlId: 3,
            friendlyName: 'Front Fan',
        },
        {
            controlId: 4,
            friendlyName: 'Rear Fan',
        },
        {
            controlId: 18,
            friendlyName: 'Day Shades',
        },
        {
            controlId: 19,
            friendlyName: 'Night Shades',
        },
        {
            controlId: 21,
            friendlyName: 'Front HVAC',
        },
        {
            controlId: 22,
            friendlyName: 'Rear HVAC',
        },
        {
            controlId: 23,
            friendlyName: 'On Board',
        },
        {
            controlId: 26,
            friendlyName: 'Away',
        },
        {
            controlId: 25,
            friendlyName: 'Sleep',
        },
        {
            controlId: 24,
            friendlyName: 'Cinema',
        },
    ],
    updatedAt: '2020-02-27T23:52:17Z',
};
//# sourceMappingURL=classic33.js.map